export default __webpack_public_path__ + "static/media/mini_list.5dc8350e.svg";